"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var e = require("react"),
    t = require("@react-pdf-viewer/core");

function n(e) {
  if (e && e.__esModule) return e;
  var t = Object.create(null);
  return e && Object.keys(e).forEach(function (n) {
    if ("default" !== n) {
      var r = Object.getOwnPropertyDescriptor(e, n);
      Object.defineProperty(t, n, r.get ? r : {
        enumerable: !0,
        get: function get() {
          return e[n];
        }
      });
    }
  }), t.default = e, Object.freeze(t);
}

var r = n(e),
    _a = function a() {
  return _a = Object.assign || function (e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      for (var a in t = arguments[n]) {
        Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
      }
    }

    return e;
  }, _a.apply(this, arguments);
},
    i = function i(e) {
  var n = e.getPageIndex,
      a = e.store,
      i = r.useState(),
      u = i[0],
      c = i[1],
      o = function o(e) {
    c(e);
  },
      s = window.devicePixelRatio || 1,
      l = r.useRef(),
      g = r.useRef(),
      f = r.useState(!1),
      h = f[0],
      p = f[1];

  return r.useEffect(function () {
    if (u) {
      var e = g.current,
          t = l.current;

      if (e && t) {
        var r = u.numPages,
            a = n ? n({
          numPages: r
        }) : 0,
            i = Math.max(0, Math.min(a, r - 1));
        u.getPage(i + 1).then(function (n) {
          var r = n.getViewport({
            scale: 1
          }),
              a = r.width,
              i = r.height,
              u = e.clientWidth,
              c = e.clientHeight,
              o = Math.min(u / a, c / i),
              l = o * a,
              g = o * i;
          t.height = g * s, t.width = l * s, t.style.opacity = "0";
          var f = t.getContext("2d", {
            alpha: !1
          }),
              h = n.getViewport({
            rotation: 0,
            scale: o * s
          });
          n.render({
            canvasContext: f,
            viewport: h
          }).promise.then(function () {
            p(!0), t.style.removeProperty("opacity");
          }, function () {
            p(!0);
          });
        });
      }
    }
  }, [u]), r.useEffect(function () {
    return a.subscribe("doc", o), function () {
      a.unsubscribe("doc", o);
    };
  }, []), r.createElement("div", {
    className: "rpv-thumbnail__cover",
    ref: g
  }, !h && r.createElement("div", {
    className: "rpv-thumbnail__cover-loader"
  }, r.createElement(t.Spinner, null)), r.createElement("canvas", {
    ref: l,
    style: {
      transform: "scale(" + 1 / s + ")",
      transformOrigin: "top left"
    }
  }));
},
    u = function u(e) {
  var n = e.page,
      a = e.pageHeight,
      i = e.pageIndex,
      u = e.pageWidth,
      c = e.rotation,
      o = e.thumbnailHeight,
      s = e.thumbnailWidth,
      l = r.useContext(t.LocalizationContext).l10n,
      g = r.useRef(),
      f = r.useState(""),
      h = f[0],
      p = f[1],
      d = l && l.thumbnail ? l.thumbnail.thumbnailLabel : "Thumbnail of page {{pageIndex}}";
  return r.useEffect(function () {
    var e = g.current;
    e && e.cancel();
    var t = document.createElement("canvas"),
        r = t.getContext("2d", {
      alpha: !1
    }),
        i = s,
        o = i / (u / a),
        l = i / u;
    t.height = o, t.width = i, t.style.height = o + "px", t.style.width = i + "px";
    var f = n.getViewport({
      rotation: c,
      scale: l
    });
    g.current = n.render({
      canvasContext: r,
      viewport: f
    }), g.current.promise.then(function () {
      return p(t.toDataURL());
    }, function () {});
  }, [c]), h ? r.createElement("img", {
    "aria-label": d.replace("{{pageIndex}}", "" + (i + 1)),
    src: h,
    height: o + "px",
    width: s + "px"
  }) : r.createElement(t.Spinner, null);
},
    c = function c(e) {
  var n = e.doc,
      a = e.isActive,
      i = e.pageHeight,
      c = e.pageIndex,
      o = e.pageWidth,
      s = e.rotation,
      l = e.onActive,
      g = r.useState({
    height: i,
    isCalculated: !1,
    page: null,
    viewportRotation: 0,
    width: o
  }),
      f = g[0],
      h = g[1],
      p = r.useRef({
    isVisible: !1,
    ratio: 0
  }),
      d = f.isCalculated,
      b = f.page,
      m = f.height,
      v = f.width,
      x = v / m,
      E = Math.abs(s) % 180 == 0,
      P = E ? 100 : 100 / x,
      w = E ? 100 / x : 100;
  r.useLayoutEffect(function () {
    if (a) {
      var e = _.current,
          t = p.current;
      (!t.isVisible || t.ratio < 1) && l(e);
    }
  }, [a]);

  var y = (s + f.viewportRotation) % 360,
      _ = t.useIntersectionObserver({
    onVisibilityChanged: function onVisibilityChanged(e) {
      p.current = e, e.isVisible && !d && n.getPage(c + 1).then(function (e) {
        var t = e.getViewport({
          scale: 1
        });
        h({
          height: t.height,
          isCalculated: !0,
          page: e,
          viewportRotation: t.rotation,
          width: t.width
        });
      });
    }
  });

  return r.createElement("div", {
    className: "rpv-thumbnail__container",
    ref: _,
    style: {
      height: w + "px",
      width: P + "px"
    }
  }, b ? r.createElement(u, {
    page: b,
    pageHeight: E ? m : v,
    pageIndex: c,
    pageWidth: E ? v : m,
    rotation: y,
    thumbnailHeight: w,
    thumbnailWidth: P
  }) : r.createElement(t.Spinner, null));
},
    o = function o(e) {
  var n = e.currentPage,
      a = e.doc,
      i = e.labels,
      u = e.pageHeight,
      o = e.pageWidth,
      s = e.renderCurrentPageLabel,
      l = e.rotation,
      g = e.onJumpToPage,
      f = a.numPages,
      h = i.length,
      p = r.useRef(null),
      d = r.useRef([]),
      b = r.useState(n),
      m = b[0],
      v = b[1],
      x = r.useContext(t.ThemeContext).direction === t.TextDirection.RightToLeft,
      E = function E(e) {
    var t = p.current;
    t && function (e, t) {
      var n = e.getBoundingClientRect().top - t.getBoundingClientRect().top,
          r = e.clientHeight,
          a = t.clientHeight;
      n < 0 ? t.scrollTop += n : n + r <= a || (t.scrollTop += n + r - a);
    }(e.parentElement, t);
  },
      P = function P() {
    if (p.current) {
      var e = d.current,
          t = m + 1;
      t < e.length && (m >= 0 && e[m].setAttribute("tabindex", "-1"), v(t));
    }
  },
      w = function w() {
    if (p.current) {
      var e = d.current,
          t = m - 1;
      t >= 0 && (m >= 0 && e[m].setAttribute("tabindex", "-1"), v(t));
    }
  },
      y = function y() {
    m >= 0 && m < f && g(m);
  };

  return t.useIsomorphicLayoutEffect(function () {
    var e = p.current;
    e && (d.current = Array.from(e.querySelectorAll(".rpv-thumbnail__item")));
  }, []), r.useEffect(function () {
    var e = d.current;

    if (!(0 === e.length || m < 0 || m > e.length)) {
      var t = e[m];
      t.setAttribute("tabindex", "0"), t.focus();
    }
  }, [m]), r.createElement("div", {
    ref: p,
    "data-testid": "thumbnail__list",
    className: t.classNames({
      "rpv-thumbnail__list": !0,
      "rpv-thumbnail__list--rtl": x
    }),
    onKeyDown: function onKeyDown(e) {
      switch (e.key) {
        case "ArrowDown":
          P();
          break;

        case "ArrowUp":
          w();
          break;

        case "Enter":
          y();
      }
    }
  }, Array(f).fill(0).map(function (e, p) {
    var d = h === f ? i[p] : "" + (p + 1),
        b = s ? s({
      currentPage: n,
      pageIndex: p,
      numPages: f,
      pageLabel: d
    }) : d;
    return r.createElement("div", {
      key: "thumbnail-" + p
    }, r.createElement("div", {
      className: t.classNames({
        "rpv-thumbnail__item": !0,
        "rpv-thumbnail__item--selected": n === p
      }),
      role: "button",
      tabIndex: n === p ? 0 : -1,
      onClick: function onClick() {
        return g(p);
      }
    }, r.createElement(c, {
      doc: a,
      isActive: n === p,
      pageHeight: u,
      pageIndex: p,
      pageWidth: o,
      rotation: l,
      onActive: E
    })), r.createElement("div", {
      className: "rpv-thumbnail__index"
    }, b));
  }));
},
    s = function s(e) {
  var n = e.renderCurrentPageLabel,
      a = e.store,
      i = function (e) {
    var t = r.useState([]),
        n = t[0],
        a = t[1],
        i = function i(e) {
      e.getPageLabels().then(function (e) {
        a(e || []);
      });
    };

    return r.useEffect(function () {
      return e.subscribe("doc", i), function () {
        e.unsubscribe("doc", i);
      };
    }, []), n;
  }(a),
      u = r.useState(),
      c = u[0],
      s = u[1],
      l = r.useState(a.get("currentPage") || 0),
      g = l[0],
      f = l[1],
      h = r.useState(a.get("pageHeight") || 0),
      p = h[0],
      d = h[1],
      b = r.useState(a.get("pageWidth") || 0),
      m = b[0],
      v = b[1],
      x = r.useState(a.get("rotation") || 0),
      E = x[0],
      P = x[1],
      w = function w(e) {
    f(e);
  },
      y = function y(e) {
    s(e);
  },
      _ = function _(e) {
    d(e);
  },
      C = function C(e) {
    v(e);
  },
      S = function S(e) {
    P(e);
  };

  return r.useEffect(function () {
    return a.subscribe("doc", y), a.subscribe("pageHeight", _), a.subscribe("pageWidth", C), a.subscribe("rotation", S), function () {
      a.unsubscribe("doc", y), a.unsubscribe("pageHeight", _), a.unsubscribe("pageWidth", C), a.unsubscribe("rotation", S);
    };
  }, []), t.useIsomorphicLayoutEffect(function () {
    return a.subscribe("currentPage", w), function () {
      a.unsubscribe("currentPage", w);
    };
  }, []), c ? r.createElement(o, {
    currentPage: g,
    doc: c,
    labels: i,
    pageHeight: p,
    pageWidth: m,
    renderCurrentPageLabel: n,
    rotation: E,
    onJumpToPage: function onJumpToPage(e) {
      var t = a.get("jumpToPage");
      t && t(e);
    }
  }) : r.createElement("div", {
    className: "rpv-thumbnail__loader"
  }, r.createElement(t.Spinner, null));
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */


exports.thumbnailPlugin = function (e) {
  var n = r.useMemo(function () {
    return t.createStore({});
  }, []);
  return {
    install: function install(e) {
      n.update("jumpToPage", e.jumpToPage);
    },
    onDocumentLoad: function onDocumentLoad(e) {
      n.update("doc", e.doc);
    },
    onViewerStateChange: function onViewerStateChange(e) {
      return n.update("currentPage", e.pageIndex), n.update("pageHeight", e.pageHeight), n.update("pageWidth", e.pageWidth), e;
    },
    Cover: function Cover(e) {
      return r.createElement(i, _a({}, e, {
        store: n
      }));
    },
    Thumbnails: function Thumbnails() {
      return r.createElement(s, {
        renderCurrentPageLabel: null == e ? void 0 : e.renderCurrentPageLabel,
        store: n
      });
    }
  };
};